module.exports = __webpack_public_path__ + "img/home3.ec911883.gif";